<template>
  <BaseForm
    :key="truckId || 'new'"
    :title="formTitle"
    :formData="truckData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    truckId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      truckData: {
        name: '',
        hauler_id: ''
      },
      fields: [
        { model: 'name', label: 'Truck Name', required: true, type: 'text' },
        { model: 'hauler_id', label: 'Hauler', required: true, type: 'select', optionsUrl: '/api/v1/hauler/haulers/', labelField: 'name' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.truckId ? `Edit Truck` : 'Add Truck';
    },
    submitUrl() {
      return this.truckId ? `/api/v1/truck/trucks/${this.truckId}/` : '/api/v1/truck/trucks/';
    },
    method() {
      return this.truckId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.truckId) {
      this.loadTruckData();
    }
  },
  methods: {
    loadTruckData() {
      axios.get(`/api/v1/truck/trucks/${this.truckId}/`).then(response => {
        console.log(response.data);
        this.truckData = {
          ...response.data,
          hauler_id: response.data.hauler_id.id
        };
      }).catch(error => {
        console.error("Failed to load truck data", error);
      });
    },
    handleSuccess(response) {
      this.$emit('update-success', response.data);
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Truck data saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'Failed to save truck data!',
        icon: 'error',
        timeout: 3000
      });
      console.error("Error saving truck data", error);
    }
  }
};
</script>
